import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainStructure from '../components/general/MainStructure';
import ListView from './listview/ListView';
import * as Icon from 'react-feather';
import { Link, useLocation } from 'react-router-dom';

function Publish() {
  const navigate = useNavigate();
  const location = useLocation();
  const isPath = (path) => location.pathname === path;

  return (
    <MainStructure activeItem={"publish"}>
      <div className="container-fluid p-0">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h1 className="h3 mb-1" style={{ fontWeight: 800, letterSpacing: '-0.3px', color: '#0f172a' }}>Publish</h1>
            <p className="mb-0 small" style={{ color: '#64748b' }}>Your publishing history, most recent first</p>
          </div>

          <div className="d-flex align-items-center gap-3">
            <button
              onClick={() => navigate('/write-post')}
              style={{
                background: '#4f46e5', color: '#fff', border: 'none',
                borderRadius: 9, padding: '8px 18px', fontWeight: 600,
                fontSize: 13, display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer',
              }}
            >
              <Icon.Plus size={15} strokeWidth={3} /> New Post
            </button>

            {/* List / Calendar toggle */}
            <div style={{ background: '#f1f5f9', borderRadius: 10, padding: 4, display: 'inline-flex', border: '1px solid #e2e8f0' }}>
              <Link
                to="/publish"
                style={{
                  padding: '7px 16px', borderRadius: 7, border: 'none',
                  background: isPath('/publish') ? '#fff' : 'transparent',
                  boxShadow: isPath('/publish') ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                  color: isPath('/publish') ? '#4f46e5' : '#64748b',
                  fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6,
                  textDecoration: 'none', transition: 'all 0.15s',
                }}
              >
                <Icon.List size={14} strokeWidth={isPath('/publish') ? 3 : 2} /> List
              </Link>
              <Link
                to="/calendar-home"
                style={{
                  padding: '7px 16px', borderRadius: 7, border: 'none',
                  background: isPath('/calendar-home') ? '#fff' : 'transparent',
                  boxShadow: isPath('/calendar-home') ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                  color: isPath('/calendar-home') ? '#4f46e5' : '#64748b',
                  fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6,
                  textDecoration: 'none', transition: 'all 0.15s',
                }}
              >
                <Icon.Calendar size={14} strokeWidth={isPath('/calendar-home') ? 3 : 2} /> Calendar
              </Link>
            </div>
          </div>
        </div>

        <ListView />
      </div>
    </MainStructure>
  );
}

export default Publish;
